import React, { useState } from "react";
import "./style.scss";

// Interfaces para tipagem organizada do TypeScript
interface VideoItem {
  id: number;
  nome: string;
  detalhe: string;
  duracao: string;
  status: "positive" | "atencao" | "negative";
  videoUrl: string;
}

interface MiniaturaItem {
  id: number;
  titulo: string;
  duracao: string;
  thumbUrl: string;
}

const VideosInstalacao = () => {
  const mockBibliotecaVideos = {
    playlistLocalidades: [
      {
        id: 74,
        nome: "UNIDASUL - Loja 74 (RS)",
        detalhe: "Casa de bombas - Módulo central",
        duracao: "01:12",
        status: "positive",
        videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4",
      }, // URLs reais de teste tag video
      {
        id: 550,
        nome: "ASSAÍ - Loja 550 (SP)",
        detalhe: "Painel elétrico - Chave Aut/Man",
        duracao: "00:48",
        status: "atencao",
        videoUrl: "https://www.w3schools.com/html/movie.mp4",
      },
      {
        id: 10,
        nome: "HAVAN (SC)",
        detalhe: "RTI - Sensores de nível",
        duracao: "01:36",
        status: "positive",
        videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4",
      },
      {
        id: 20,
        nome: "GPA (SP)",
        detalhe: "Sinóptico - Alarmes",
        duracao: "00:55",
        status: "positive",
        videoUrl: "https://www.w3schools.com/html/movie.mp4",
      },
      {
        id: 30,
        nome: "CONDOR (PR)",
        detalhe: "Bombas Jockey - Relê térmico",
        duracao: "01:05",
        status: "atencao",
        videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4",
      },
      {
        id: 40,
        nome: "BRAVO (SP)",
        detalhe: "Etapas de Instalação",
        duracao: "02:10",
        status: "negative",
        videoUrl: "https://www.w3schools.com/html/movie.mp4",
      },
    ] as VideoItem[],
    miniaturasEvidencias: [
      { id: 1, titulo: "Painel elétrico", duracao: "00:48", thumbUrl: "" },
      { id: 2, titulo: "RTI", duracao: "01:36", thumbUrl: "" },
      { id: 3, titulo: "Sinóptico", duracao: "00:55", thumbUrl: "" },
      { id: 4, titulo: "Bombas", duracao: "01:05", thumbUrl: "" },
      { id: 5, titulo: "Sala máquinas", duracao: "00:42", thumbUrl: "" },
      { id: 6, titulo: "Etapas", duracao: "02:10", thumbUrl: "" },
      { id: 7, titulo: "Finalização", duracao: "00:58", thumbUrl: "" },
      { id: 8, titulo: "Teste", duracao: "00:33", thumbUrl: "" },
    ] as MiniaturaItem[],
  };

  // Estado para gerenciar qual vídeo está tocando no painel central
  const [videoAtivo, setVideoAtivo] = useState<VideoItem>(
    mockBibliotecaVideos.playlistLocalidades[0],
  );

  return (
    <div className="biblioteca-videos-container">
      <header className="main-header-videos">
        <div className="logos-side">
          <span className="logo-ikone">ÍKONE</span>
          <span className="divisor-pipe">|</span>
          <span className="logo-sompo">SOMPO</span>
        </div>
        <div className="title-side">
          <h2>Vídeos de Instalação</h2>
          <p>Evidências gravadas para o cliente</p>
        </div>
      </header>

      <main className="painel-moldura-sompo">
        <div className="sub-header-painel">
          <h3>
            Biblioteca de vídeos <span>(não é monitoramento ao vivo)</span>
          </h3>
        </div>

        <div className="grid-conteudo-video">
          <section className="playlist-sidebar">
            <h4 className="title-section-playlist">Playlist por localidade</h4>
            <div className="scroll-playlist">
              {mockBibliotecaVideos.playlistLocalidades.map((item) => (
                <div
                  key={item.id}
                  className={`card-item-playlist ${videoAtivo.id === item.id ? "active" : ""}`}
                  onClick={() => setVideoAtivo(item)}
                >
                  <div className="info-item-head">
                    <div className="nome-status">
                      <span className={`dot-status ${item.status}`}></span>
                      <strong className="nome-loja">{item.nome}</strong>
                    </div>
                    <span className="time-badge">{item.duracao}</span>
                  </div>
                  <p className="detalhe-subtexto">{item.detalhe}</p>
                  <div className="play-icon-indicator">▶</div>
                </div>
              ))}
            </div>
          </section>

          <section className="player-workspace">
            <div className="wrapper-video-html5">
              <video
                key={videoAtivo.videoUrl}
                controls
                poster=""
                className="main-video-player"
              >
                <source src={videoAtivo.videoUrl} type="video/mp4" />
                Seu navegador não suporta a tag de vídeo.
              </video>
            </div>

            <div className="player-footer-metadata">
              <h4>{videoAtivo.nome} — evidência de instalação</h4>
              <p>{videoAtivo.detalhe}</p>
            </div>
          </section>
        </div>

        <footer className="secao-miniaturas-evidencias">
          <h4>Miniaturas (últimas evidências)</h4>
          <div className="grid-miniaturas">
            {mockBibliotecaVideos.miniaturasEvidencias.map((miniatura) => (
              <div key={miniatura.id} className="card-miniatura-video">
                <div className="preview-thumb-ficticio">
                  <div className="play-mini-btn">▶</div>
                  <span className="time-mini">{miniatura.duracao}</span>
                </div>
                <div className="footer-mini-title">
                  <p>{miniatura.titulo}</p>
                </div>
              </div>
            ))}
          </div>
        </footer>
      </main>
    </div>
  );
};

export default VideosInstalacao;
